import React, { memo } from 'react';

import { StyledTag } from './ArchivedTag.styles';

const ArchivedTag = (props) => <StyledTag label="Archived" {...props} />;

export default memo(ArchivedTag);
